import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MpsUserService } from '../services/mps-user.service';
import { applicationRouteNames } from '../../app/application-route-names';

export const MpsGuestGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);

  return userService.isLoggedIn() ? router.navigateByUrl(applicationRouteNames.home) : true;
};
